export function Card({
  children,
  className,
  style,
}: {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}) {
  return (
    <div
      className={`bg-white shadow-[0px_4px_24px_0px_rgba(203,90,90,0.05)] px-6 py-4 rounded-[14px] ${className}`}
      style={style}
    >
      {children}
    </div>
  );
}
